export const getAvatarText = (name: string) => {
    if (name) {
      const names = name.split(" ");
      if (names.length > 1) {
        return names[0][0].toUpperCase() + names[1][0].toUpperCase();
      } else {
        return names[0][0].toUpperCase();
      }
    }
  };